import axios from "axios";
import ClientSession from "./client-session.js";
import {API_BASE_URL} from "./configurations.js";


export default class API {
  static API_BASE_URL = API_BASE_URL;
  static  HOME = "{$competitor1}"
  static  AWAY = "{$competitor2}"

  static create(pluralName, data, filter = null) {
    let url = API_BASE_URL + pluralName + '/';
    if (filter) url += "?" + filter;

    return new Promise(function (resolve, reject) {
      let config = { headers: {} }
      ClientSession.getAccessToken(function (isLoggedIn, authData) {
        if (isLoggedIn && authData != null) {
          config.headers.Authorization = 'token ' + authData.token;
        }

        axios
          .post(url, data, config)
          .then(response => resolve(response))
          .catch(error => reject(error.response));
      });
    });
  }

  static find(pluralName, id, filter) {
    let url = API_BASE_URL + pluralName;

    if (id) url += "/" + id;
    if (filter) url += "?" + filter;

    return new Promise(function (resolve, reject) {
      let config = { headers: {} }
      ClientSession.getAccessToken(function (isLoggedIn, authData) {
        if (isLoggedIn && authData != null) {
          config.headers.Authorization = 'token ' + authData.token;
        }

        axios
          .get(url, config)
          .then(response => resolve(response))
          .catch(error => reject(error.response));
      });
    });
  }


  static update(pluralName, id, data) {
    let url = API_BASE_URL + pluralName + "/"
    if (id) url += id + '/';

    return new Promise(function (resolve, reject) {
      let config = { headers: {} }
      ClientSession.getAccessToken(function (isLoggedIn, authData) {
        if (isLoggedIn && authData != null) {
          config.headers.Authorization = 'token ' + authData.token;
        }

        axios({
          method: "put",
          url: url,
          data: data,
          headers: config.headers
        })
          .then(response => resolve(response))
          .catch(error => reject(error.response));
      });
    });
  }


  static destroy(pluralName, id) {
    let url = API_BASE_URL + pluralName + "/" + id;

    return new Promise(function (resolve, reject) {
      let config = { headers: {} }
      ClientSession.getAccessToken(function (isLoggedIn, authData) {
        if (isLoggedIn && authData != null) {
          config.headers.Authorization = 'token ' + authData.token;
        }
        axios({
          method: "delete",
          url: url,
          headers: config.headers
        })
          .then(response => resolve(response))
          .catch(error => reject(error.response));
      });
    });
  }
    // Utiltity fucntion to format bet type and bet groups 
    static replaceAll = (data, search, replacement) => {
      return data.split(search).join(replacement)
  
    }
  
    static parseSpecifier = ( specifiers ) => {
      if ( !specifiers )
      return []
      
      specifiers = specifiers.split("|")
      return specifiers.map( specifier => {
        specifier = specifier.split("=")
        return {name : specifier[0], value : specifier[1]}
      })
    
    }
  
    static replaceVariablesForSpecifier = (specifiers, data, event) => {
      specifiers = API.parseSpecifier(specifiers)
  
      specifiers.forEach( specifier => {
        data = API.replaceAll(data,  `{${specifier.name}}`, specifier.value )
      })
      
      if ( event) { 
        let home_ = event.hom && event.hom || event
        let away_ = event.awy && event.awy || event
  
        data = API.replaceAll(data, API.HOME, home_)
        data = API.replaceAll(data, API.AWAY, away_)
      }
  
      return data
    
    }
  
    static formatBetTypeame = (name, event, param) => {
      return API.replaceVariablesForSpecifier(param, name, event )
    }
  
    static formatBetGroupame = (name, param, event) => {
  
      return API.replaceVariablesForSpecifier(param, name, event  )
  
    }

}
